import React from 'react';

// Small colored monogram, not Upwork's actual logomark — avoids trademark risk
// while still reading clearly as "this lead came from Upwork" at a glance.
export default function UpworkBadge({ size = 14, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      aria-label="Upwork"
    >
      <title>Upwork</title>
      <circle cx="8" cy="8" r="8" fill="#14a800" />
      <text x="8" y="11.5" textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">
        U
      </text>
    </svg>
  );
}
